import React, { FC } from 'react';

import { ArrowUpOutlined, UserAddOutlined } from '@ant-design/icons';
import CountUp from 'react-countup';
import { T } from 'react-translator-component';

import ChargerIcon from '../../../atoms/icons/ChargerIcon';
import Card from '../../Card';

export type UserIndicatorProps = {
  usersCharged: number;
  usersRegistered: number;
};

const UserIndicator: FC<UserIndicatorProps> = ({
  usersCharged = 0,
  usersRegistered = 0
}) => (
  <Card
    title={T('Users')}
    indicators={[
      {
        values: (
          <div className='description_registered_wrapper'>
            <UserAddOutlined className='indicators--icon' style={{ color: '#007c0c' }} />
            <CountUp className='number_registered' start={0} end={usersRegistered} duration={3} />
          </div>
        ),
        labels: (
          <div className='description_registered_wrapper'>
            <ArrowUpOutlined style={{ color: '#007c0c' }} />
            <p className='description_registered'>{usersRegistered == 1 ? T('Registered user') : T('Registered users')}</p>
          </div>
        )
      },
      {
        values: (
          <div className='description_registered_wrapper'>
            <ChargerIcon fill='#3a89ff' className="indicators--chargeicon"  />
            <CountUp className='number_charged' start={0} end={usersCharged} duration={3} />
          </div>
        ),
        labels: (
          <div className='description_registered_wrapper'>
            <ArrowUpOutlined style={{ color: '#3a89ff' }} />
            <p className='description_registered'>{usersCharged == 1 ? T('User charged') : T('Users charged')}</p>
          </div>
        )
      }
    ]}
  />
);

export default UserIndicator;
